export const NAVIGATION_MENU = [
  // {
  //   name: 'Tenant',
  //   key: 'tenant',
  //   path: '/tenant',
  // },
  {
    name: 'TENANCY',
    key: 'setup',
    path: '/setup',
  },
  {
    name: 'Roster',
    key: 'users-rosters',
    path: '/users-rosters',
  },
  {
    name: 'Learn Store',
    key: 'learn-store',
    subMenu: [
      {
        name: 'Content Registry',
        path: '/content-registry',
        key: 'content-registry',
      }, {
        name: 'Tools Registry',
        path: '/tool-registry',
        key: 'tool-registry',
      }, {
        name: 'Partner Registry',
        path: '/partner-registry',
        key: 'partner-registry',
      }],
  },
  {
    name: 'Learning Registry',
    key: 'partner-catalog',
    path: '/partner-catalog',
  },
  {
    name: 'Data Lake',
    key: 'data-lake',
    path: '/data-lake',
  },
   {
    name: 'My Gooru',
    key: 'my-gooru',
    path: '/my-gooru',
  },
  {
    name: 'Approval Requests',
    key: 'approval-requests',
    path: '/approval-request',
  },
  {
    name: 'Independent Study',
    key: 'independent-study',
    path: '/independent-study',
  },
  // {
  //   name: 'console',
  //   key: 'console',
  //   path: '/console',
  // },
  {
    name: `Recruiters`,
    key: 'recruiters',
    path: '/job-boards',
  },
  {
    name: 'Community Hub',
    key: 'community-hub',
    path: '/community-hub',
  },
];

export const NAVIGATION_MENU_ROSTER = [
  {
    name: 'Roster',
    key: 'users-rosters',
    path: '/users-rosters',
  },
];

export const CONTENT_TYPE = [
  {
    labelKey: 'content.assessment',
    type: 'assessment',
  },
  {
    labelKey: 'content.collection',
    type: 'collection',
  },
  {
    labelKey: 'content.resource',
    type: 'resource',
  },
  {
    labelKey: 'content.offline.activity',
    type: 'offline-activity',
  },
  {
    labelKey: 'content.course',
    type: 'course',
  },
  {
    labelKey: 'content.question',
    type: 'question',
  },
];



export const DEFAULT_IMAGES_PATH: any = {
  profile: '/img/default-images/profile.png',
  partner: '/img/default-images/partner.png',
  collection: '/img/default-images/collection-default.png',
  assessment: '/img/default-images/assessment-default.png',
};


export const LEARNING_MAP_CONTENT_TYPE = [
  {
    labelKey: 'assessment',
    type: 'assessment',
  },
  {
    labelKey: 'collection',
    type: 'collection',
  },
  {
    labelKey: 'resource',
    type: 'resource',
  },
  {
    labelKey: 'offline activity',
    type: 'offline-activity',
  },
  {
    labelKey: 'course',
    type: 'course',
  },
  {
    labelKey: 'question',
    type: 'question',
  },
  {
    labelKey: 'lesson',
    type: 'lesson',
  },
  {
    labelKey: 'unit',
    type: 'unit',
  },
  {
    labelKey: 'rubric',
    type: 'rubric',
  },
];

export const GRADING_SCALE = [{
  LOWER_LIMIT: 0,
  COLOR: '#F46360',
  RANGE: '0-59',
},
{
  LOWER_LIMIT: 60,
  COLOR: '#ED8E36',
  RANGE: '60-69',
},
{
  LOWER_LIMIT: 70,
  COLOR: '#FABA36',
  RANGE: '70-79',
},
{
  LOWER_LIMIT: 80,
  COLOR: '#A8C99C',
  RANGE: '80-89',
},
{
  LOWER_LIMIT: 90,
  COLOR: '#4B9740',
  RANGE: '90-100',
},
];

export const LEARNER_PREFERENCE_META: any = {
  video: {
    labelKey: 'Video Resources',
    icon: 'video-resource',
  },
  webpage: {
    labelKey: 'Web Based Resources',
    icon: 'website-resource',
  },
  interactive: {
    labelKey: 'Interactive Resources',
    icon: 'interactive-resource',
  },
  image: {
    labelKey: 'Image Resources',
    icon: 'image-resource',
  },
  text: {
    labelKey: 'Text Resources',
    icon: 'text-resource',
  },
  audio: {
    labelKey: 'Audio Resources',
    icon: 'audio-resource',
  },
  project: {
    labelKey: 'Project',
    icon: 'offline-activity-gray',
  },
};

export const COMPETENCY_NAVIGATION_MENUS = [
  'competency-map',
  'tree',
  'crosswalk',
  'learning-map',
];

export const GOORU_DEFAULT_STANDARD = 'GDF';

export const GOORU_DEFAULT_FRAMEWORK = 'GDT';

export const MICRO_COMPETENCY_CODE_TYPES = [
  'learning_target_level_0',
  'learning_target_level_1',
  'learning_target_level_2',
];

export const TAXONOMY_LEVELS = {
  COURSE: 'course',
  DOMAIN: 'domain',
  STANDARD: 'standard',
  MICRO: 'micro-standard',
};

export const LEARNER_MINDSETS_VECTORS = [
  'grit',
  'perseverance',
  'motivation',
  'selfConfidence',
];

export const LEARNER_COMMUNITY_VECTORS = [
  'citizenship',
  'authority',
  'reputation',

];
export const DEMO_USERS = [
  'e062559a-35d2-45e9-85fd-380987dc2fdf',
];

export const PERMISSION_LIST = {
  consoleView: 'console-view',
  console: 'console',
  all: 'all',
  roleView: 'role-view',
};

export const ROLE_MENUS = {
  console: 'console',
  nav: 'nav',
  all: 'all',
};

export const FACETS_MENU = {
  publishers: 'publishers',
  products: 'products',
  categories: 'categories',
};

export const TENANT_SETTINGS_KEYS_MAPPING: any = {
  tx_sub_classifier_prefs: {
    title: 'Framework Categories/Disciplines',
    key: 'tx-loader',
    action: 'categoryLists',
  },
  allow_multi_grade_class: {
    title: 'Allow multi grade class',
    key: 'toggle-switch',
  },
  competency_completion_default_min_score: {
    title: 'Competency Completion default min score',
    key: 'default-min-score',
  },
  default_password: {
    title: 'Default password',
    key: 'default-password',
    description: 'The default password that is set up for the users with credential-based login',
  },
  diagnostic_setting: {
    title: 'Diagnostic setting',
    key: 'diagnostic-level',
  },
  enable_cls_video_conf_setup: {
    title: 'Enable video conference',
    key: 'toggle-switch',
    description: 'Allow teachers to setup video conference (Google Meet) in Class Activities',
  },
  group_hierarchy: {
    title: 'Group hierarchy',
    key: 'group-heirarchy',
  },
  language_instruction: {
    title: 'Language of Instruction',
    key: '',
  },
  navigator_class_setting: {
    title: 'Navigator Class Setting',
    key: 'nav-class-setup',
    action: 'categoryLists',
  },
  user_consent: {
    title: 'User Consent',
    key: '',
  },

  // competency_completion_min_score: {
  //   title: 'Minimum Score for Mastery',
  //   key: 'cm-completion-score',
  //   action: 'categoryLists',
  // },

  white_labeling: {
    title: 'White Labeling',
    key: '',
  },


};


export const WHITE_LABELING_SETTINGS_KEYS_MAPPING: any = {
  translation_setting: {
    title: 'Translation settings',
    key: 'translation-setting',
    description: 'Load tenant specific labels for Web, Mobile. Need to insert new rows for with updated values in app_translation_label_config table',
  },
  study_player_collection_show_correct_answer: {
    title: 'Study player show answer',
    key: 'toggle-switch',
    description: 'To show answer immediately after user mark in the question(from collection) on left panel from Study Player.',
  },
  allow_to_change_class_course_content_visibility: {
    title: 'Class course content visibility update allow',
    key: 'course-content-visibility',
    description: 'Content visbility allow to on/off toogle should show based on this.',
  },
  default_class_course_content_visibility: {
    title: 'Default class course content visibility',
    key: 'default-class-course-content-visibility',
    description: 'Content visbility on teacher side default will be on',
  },
  mastery_on_content_completion_setting: {
    title: 'Mastery on content completion setting',
    key: 'mastery-content-completion',
    description: 'Used to enable the mastry on the content completion. Where assessment scores will not be considered to give the mastry',
  },
  default_view_sns_at_fw_level: {
    title: 'Default view at framework level',
    key: 'default-view-fw-level',
    description: 'To show the "Show All" as default set the this key to false for Framework and Subject Code. ',
  },
  diagnostic_percentage_score: {
    title: 'Diagnostic percentage score',
    key: 'diagnostic-percentage-score',
    description: 'Allow teachers to setup video conference (Google Meet) in Class Activities',
  },
  skip_mastered_content: {
    title: 'Skip Mastered Content',
    key: 'toggle-switch',
    description: 'This setting is used in the Next logic to always serve the all contents from students LJ irrespective of the mastery status on the content.',
  },
  custom_notifications: {
    title: 'Custom Notification',
    key: 'custom-notifications',
    description: 'This settings is used to send the custom notifications',
    // action: 'categoryLists',
  },

};

export const PARTNERS_TYPE = [
  // {
  //   type: 'schools',
  //   name: 'schools',
  // },
  {
    type: 'researchers',
    name: 'researchers',
  },
  {
    type: 'content_developers',
    name: 'content developers',
  },
  // {
  //   type: 'lab_schools',
  //   name: 'lab school',
  // },
  {
    type: 'funders',
    name: 'funders',
  },
  {
    type: 'integration_partners',
    name: 'EdTech Providers',
  },
  {
    type: 'educators',
    name: 'educators',
  },
];

export const ROSTER_TOPIC_LIST = [
  {
    name: 'Orgnaizations',
    key: 'orgs-list',
    icon: 'corporate_fare',
    identifier: 'orgs',
    isHidden: true,
  },
  {
    name: 'Users',
    key: 'users-list',
    icon: 'supervisor_account',
    identifier: 'users',
  },
  {
    name: 'Academic Sessions',
    key: 'academic-list',
    icon: 'fact_check',
    identifier: 'academic',
  },
  {
    name: 'Classes',
    key: 'class-list',
    icon: 'school',
    identifier: 'class',
  },
  {
    name: 'Courses',
    key: 'courses-list',
    icon: 'chrome_reader_mode',
    identifier: 'course',
  },
  {
    name: 'Manifest',
    key: 'manifest-list',
    icon: 'article',
    identifier: 'manifest',
  },
  {
    name: 'Enrollments',
    key: 'enrollment-list',
    icon: 'article',
    identifier: 'enrollments',
  },
];

export const CUSTOM_ROSTER_SELECTION_TYPE = [
  {
    name: 'Users',
    identifier: 'rostering',
  },
  {
    name: 'Group Hierarchy',
    identifier: 'group_hierarchy',
  },
];

export const ROSTER_CSV_FORMATS: any = {
  orgs: '/roster-docs/orgs.csv',
  academic: '/roster-docs/academicSessions.csv',
  class: '/roster-docs/classes.csv',
  users: '/roster-docs/users.csv',
  enrollments: '/roster-docs/enrollments.csv',
  course: '/roster-docs/courses.csv',
  roster1: '/roster-docs/roster1.zip',
  roster0: '/roster-docs/roster1-0.zip',
  custom: 'https://docs.google.com/spreadsheets/d/1ryYGThMuBAjvx00C_CMLAyrJOM41qH2ILuBj_K60r78/edit#gid=2125628905',
  groupHierarchy: 'https://docs.google.com/spreadsheets/d/1XPeCWgIiU_EuKfymapD5xPe7jcLhb4wIMlbuwbtBR8g/edit#gid=1698285210',
};

export const ROSTER_MOTHODS: any = {
  oneRoster0: 'OneRoster 1.0',
  oneRoster1: 'OneRoster 1.1',
  custom: 'Custom Template',
  groupHierarchy: 'Group Hierarchy',
};

export const ROSTER_MOTHODS_KEYS: any = {
  oneRoster0: 'one_roster_1.0',
  oneRoster1: 'one_roster_1.1',
  custom: 'custom_template',
};

export const CUSTOM_ROSETR_HEAD: any = [
  {
    label: 'File Name',
    key: 'file_name',
    sortable: true,
    thClass: 'sticky-position',
    tdClass: 'custom-roster-file-name',
  },
  {
    label: 'Uploaded by',
    key: 'uploaded_by',
    thClass: 'sticky-position',
    sortable: true,
  },
  {
    label: 'Uploaded On',
    key: 'updated_at',
    thClass: 'sticky-position',
    sortable: true,
  },
  {
    label: 'Status',
    key: 'status',
    sortable: true,
    thClass: 'sticky-position',
  },
  {
    label: 'Actions',
    key: 'isAction',
    thClass: 'sticky-position',
  },
];

export const FILE_UPLOAD_RESPONCE: any = {
  Error: 'error',
  Accepted: 'accepted',
  SyncCompleted: 'sync-completed',
  InProgress: 'in-progress',
};

export const TOOL_TYPE: any = [
  {
    value: 'LTI',
    text: 'LTI',
  },
  {
    value: 'script',
    text: 'Script',
  },
  {
    value: 'embed',
    text: 'Embed',
  },
];

export const LTI_VERSIONS: any = [
  {
    value: '1.0',
    text: 'LTI 1.0',
  },
  {
    value: '1.1',
    text: 'LTI 1.1',
  },
  {
    value: '1.3',
    text: 'LTI 1.3',
  },
];

export const PUBLIC_KEY_TYPES: any = [
  {
    value: 'RSA',
    text: 'RSA key',
  },
  {
    value: 'JWKS',
    text: 'Keyset URL',
  },
];

export const DEFAULT_LAUNCH_CONTAINER: any = [
  {
    value: 'Embed',
    text: 'Embed',
  },
  // {
  //   value: 'Embed, without blocks',
  //   text: 'Embed, without blocks',
  // },
  ,
  {
    value: 'Existing window',
    text: 'Existing window',
  },
  ,
  {
    value: 'New window',
    text: 'New window',
  },
];

export const TOOL_CATEGORY: any = [
  {
    value: 'Curriculum',
    text: 'Curriculum',
    id: 'Curriculum',
    title: 'Curriculum',
  },
  {
    value: 'Assessment',
    text: 'Assessment',
    id: 'Assessment',
    title: 'Assessment',
  },
  {
    value: 'Utility',
    text: 'Utility',
    id: 'Utility',
    title: 'Utility',
  },
  {
    value: 'Virtual',
    text: 'Virtual',
    id: 'Virtual',
    title: 'Virtual',
  },
  {
    value: 'VR',
    text: 'VR',
    id: 'VR',
    title: 'VR',
  },
  {
    value: 'AR',
    text: 'AR',
    id: 'AR',
    title: 'AR',
  },

];

export const LAUNCH_REQUEST_METHOD: any = [
  {
    value: 'GET',
    text: 'GET',
  },
  {
    value: 'POST',
    text: 'POST',
  },
  {
    value: 'UPDATE',
    text: 'UPDATE',
  },
  // {
  //   value: 'DELETE',
  //   text: 'DELETE',
  // },
];

export const CONTENT_TYPE_FILTER: any = [
  {
    value: 'OER',
    text: 'OER',
    title: 'OER',
    id: 'OER',
  },
  {
    value: 'premium,non-premium',
    text: 'Others',
    title: 'Others',
    id: 'premium,non-premium',
  },
];

export const REGISTRY_TYPE = {
  partnerRegistry: 'partner-registry',
  contentRegistry: 'content-registry',
  toolRegistry: 'tool-registry',
};

export const PARTNERS_DATA_TYPE_FIELDS: any = {
  contentDevelopers: 'content_developers',
  funders: 'funders',
  integrationPartners: 'integration_partners',
  labSchools: 'lab_schools',
  overallStats: 'overall_stats',
  researchers: 'researchers',
  schools: 'schools',
};

export const PARTNERS_DATA_TYPE_ARRAY: any = [
  'content_developers',
  'implementers',
  'educators',
  'researchers',
  'integration_partners',
  'funders',
];

export const EDUCATORS_SUB_ARRAY: any = [
  'lab_schools',
  'schools',
];

export const EDUCATORS_SUB_OBJECT_ARRAY_WISE: any = {
  lab_schools: 'Lab schools',
  schools: 'Schools',
};

export const PARTNERS_TYPE_OBJECT_ARRAY_WISE: any = {
  content_developers: 'Content developers',
  funders: 'Funders',
  integration_partners: 'EdTech Providers',
  lab_schools: 'Lab schools',
  overall_stats: 'overall stats',
  researchers: 'Researchers',
  schools: 'Schools',
  educators: 'Educators',
  implementers: 'Implementers',
};

export const USER_TYPE = {
  superUser: 'SUPER_USER',
  contentProvider: 'CONTENT_PROVIDER',
  districtUser: 'DISTRICT_USER',
};

export const PARTNERS_TYPE_OBJECT: any = {
  contentDevelopers: 'Content developers',
  funders: 'Funders',
  integrationPartners: 'Integration partners',
  labSchools: 'Lab schools',
  overallStats: 'overall stats',
  researchers: 'Researchers',
  schools: 'Schools',
};

export const PARTNERS_TYPE_ARRAY: any = [
  'content_developers',
  'implementers',
  'educators',
  'lab_schools',
  'researchers',
  'integration_partners',
  'funders',
  'schools',
];

export const PARTNERS_REGISTRY_TABLE_FIELDS: any = {
  content_developers: [
    {
      label: 'Content Developer',
      key: 'partner_name',
      tdClass: 'content-provider-colm-1',
    },
    {
      label: 'About',
      key: 'notes',
      tdClass: 'content-provider-about',
    },
    {
      label: 'Subjects',
      key: 'subject',
    },
    {
      label: 'Grade Range',
      key: 'gradeLevels',
    },
    {
      label: '# of Products',
      key: 'data_count',
    },
  ],
  funders: [
    {
      label: 'Funder',
      key: 'partner_name',
    },
    {
      label: 'Country',
      key: 'countries',
    },
    {
      label: 'Type',
      key: 'providerName1',
    },
    {
      label: 'About',
      key: 'notes',
    },
  ],
  integration_partners: [
    {
      label: 'Provider',
      key: 'partner_name',
    },
    {
      label: 'About',
      key: 'notes',
      tdClass: 'educators-about',
    },
    {
      label: 'Countries',
      key: 'countries',
    },
    {
      label: 'Type',
      key: 'providerName2',
    },
    {
      label: 'Categories',
      key: 'providerName3',
    },
    {
      label: 'Reach (# of users)',
      key: 'total_users',
    },
  ],
  researchers: [
    {
      label: 'Institute',
      key: 'partner_name',
    },
    {
      label: 'About',
      key: 'notes',
      tdClass: 'educators-about',
    },
    {
      label: 'Country',
      key: 'countries',
    },
    {
      label: 'Areas of Research',
      key: 'providerName2',
    },
    {
      label: 'Content/Tools/Algorithms',
      key: 'providerName3',
    },
  ],
  educators: [
    {
      label: 'Educator',
      key: 'partner_name',
    },
    {
      label: 'About',
      key: 'notes',
      tdClass: 'educators-about',
    },
    {
      label: 'Country',
      key: 'countries',
    },
    {
      label: 'Categories',
      key: 'providerName2',
    },
    {
      label: '# of schools/institutions',
      key: 'providerName3',
    },
    {
      label: '# of users',
      key: 'total_users',
    },
  ],
  implementers: [
    {
      label: 'Implementer',
      key: 'partner_name',
    },
    {
      label: 'About',
      key: 'notes',
    },
    {
      label: 'Country',
      key: 'providerName1',
    },
    {
      label: 'Categories',
      key: 'providerName2',
    },
    {
      label: '# of schools/institutions',
      key: 'providerName3',
    },
    {
      label: 'Reach (# of users)',
      key: 'providerName4',
    },
  ],
};

export const REGISTRY_TABLE_FIELDS: any = {
  districtUserContent: [
    {
      label: 'Partners',
      key: 'partnerName',
    },
    {
      label: 'Product',
      key: 'productName',
    },
    {
      label: 'Description',
      key: 'productDescription',
    },
    {
      label: 'Subjects',
      key: 'subject',
    },
    {
      label: 'Grades Range',
      key: 'gradeLevels',
    },
    {
      label: 'Audience',
      key: 'audience',
    },
    {
      label: 'Status',
      key: 'subscribeStatus',
    },
  ],
  districtUserTool: [
    {
      label: 'Product',
      key: 'toolName',
    },
    {
      label: 'Providers',
      key: 'partnerName',
    },
    {
      label: 'Description',
      key: 'toolDescription',
    },
    {
      label: 'Subjects',
      key: 'subjectTitles',
    },
    {
      label: 'Grades Range',
      key: 'subjectGrdaes',
    },
    {
      label: 'Audience',
      key: 'audience',
    },
    {
      label: 'Status',
      key: 'subscribeStatus',
    },
  ],
  contentProviderContent: [
    {
      label: 'Partners',
      key: 'partnerName',
    },
    {
      label: 'Product',
      key: 'productName',
    },
    {
      label: 'Description',
      key: 'productDescription',
    },
    {
      label: 'Subjects',
      key: 'subject',
    },
    {
      label: 'Grades Range',
      key: 'gradeLevels',
    },
    {
      label: 'Audience',
      key: 'audience',
    },
  ],
  contentProviderTool: [
    {
      label: 'Product',
      key: 'productName',
    },
    {
      label: 'Providers',
      key: 'partnerName',
    },
    {
      label: 'Description',
      key: 'productDescription',
    },
    {
      label: 'Subjects',
      key: 'subject',
    },
    {
      label: 'Grades Range',
      key: 'gradeLevels',
    },
    {
      label: 'Audience',
      key: 'audience',
    },
  ],
  superUserContent: [
    {
      label: 'Product',
      key: 'providerName',
      tdClass: 'content-reg-provider',
    },
    {
      label: 'Provider',
      key: 'partnerName',
      tdClass: 'content-reg-provider',
    },
    {
      label: 'Provider',
      key: 'providerName',
      tdClass: 'content-reg-provider',
    },
    {
      label: 'Description',
      key: 'description',
    },
    {
      label: 'Subjects',
      key: 'subjectInfo',
    },
    {
      label: 'Grades Range',
      key: 'gradeInfo',
    },
    {
      label: 'Audience',
      key: 'audience',
    },
  ],
  superUserTool: [
    {
      label: 'Product',
      key: 'name',
    },
    {
      label: 'Providers',
      key: 'providerName',
    },
    {
      label: 'Description',
      key: 'description',
    },
    {
      label: 'Subjects',
      key: 'subjects',
    },
    {
      label: 'Grades Range',
      key: 'gradeLevels',
    },
    {
      label: 'Audience',
      key: 'audience',
    },
  ],
};

export const AUDIENCE_TYPE: any = [
  {
    value: 'student',
    text: 'Student',
    id: 'student',
    title: 'Student',
  },
  {
    id: 'teacher',
    title: 'Teacher',
    value: 'teacher',
    text: 'Teacher',
  },
];

export const GROUP_CODE_TYPE: any = [
  {
    value: 'OER',
    text: 'Open',
  },
  {
    value: 'premium',
    text: 'Premium',
  },
  {
    value: 'non-premium',
    text: 'Sample',
  },
];

export const ERROR_LOG_FIELDS: any = [
  {
    label: 'Row No',
    key: 'row',
    sortable: true,
  },
  {
    label: 'Column Name',
    key: 'columnName',
    sortable: true,
  },
  {
    label: 'Error Message',
    key: 'message',
    sortable: true,
  },
];

export const STATUS_CODE_MESSAGE: any = {
  201: 'Created',
  204: 'Updated',
  400: 'Error',
  500: 'Error',
};

export const CLASS_SETTINGS_MAP_KEYS: any = {
  can_impersonate_student: {
    master_tenant_settings_key: 'can_impersonate_student',
    title: 'Impersonate student for class settings',
    key: 'can_impersonate_student',
    purpose: 'Alllow teacher to impersonate student for class settings',
    description: '',
    field_type: 'toggle-switch-common',
    default_value: '',
    value: '',
    is_default: false,
  },
  allow_multi_grade_class: {
    master_tenant_settings_key: 'allow_multi_grade_class',
    title: 'Allow to view multiple  grades classes',
    key: 'allow_multi_grade_class',
    purpose: 'Allow teacher to view multiple classes of same subject from one class',
    description: '',
    field_type: 'toggle-switch-common',
    default_value: '',
    value: '',
    is_default: false,
  },
  class_add_course_filter_out_non_premium: {
    master_tenant_settings_key: 'class_add_course_filter_out_non_premium',
    title: 'Add course filter non permium',
    key: 'class_add_course_filter_out_non_premium',
    purpose: 'Add course filter non permium',
    description: '',
    field_type: 'toggle-switch-common',
    default_value: '',
    value: '',
    is_default: false,
  },
  ui_element_visibility_settings: {
    master_tenant_settings_key: 'ui_element_visibility_settings',
    title: 'UI visibility settings',
    key: 'ui_element_visibility_settings',
    purpose: 'Allow teacher to update visisbility settings',
    description: '',
    sub_group: {
      enable_create_class: {
        master_tenant_settings_key: 'ui_element_visibility_settings',
        title: 'UI visibility settings',
        key: 'enable_create_class',
        purpose: 'Show the create Class card',
        description: '',
        field_type: 'toggle-switch-common',
        default_value: '',
        value: '',
        is_default: false,
      },
      class_create_show_subject_cards: {
        master_tenant_settings_key: 'ui_element_visibility_settings',
        title: 'UI visibility settings',
        key: 'class_create_show_subject_cards',
        purpose: 'Show Class create Subject cards',
        description: '',
        field_type: 'toggle-switch-common',
        default_value: '',
        value: '',
        is_default: false,
      },
      add_students_by: {
        master_tenant_settings_key: 'ui_element_visibility_settings',
        title: 'UI visibility settings',
        key: 'add_students_by',
        purpose: 'Add students to Class with username or email',
        description: '',
        field_type: 'drop-down',
        default_value: null,
        value: 'email',
        is_default: false,
        dropDownOptions: [
          { value: 'email', text: 'Email' },
          { value: 'username', text: 'User name' },
        ],
      },
    },
  },
  default_ca_collection_type_selection: {
    master_tenant_settings_key: 'default_ca_collection_type_selection',
    title: 'Default class Assissment type selection',
    key: 'default_ca_collection_type_selection',
    purpose: 'Default class Assissment type selection',
    description: '',
    field_type: 'toggle-switch-common',
    default_value: '',
    value: '',
    is_default: false,
  },
  ca_content_sources: {
    master_tenant_settings_key: 'ca_content_sources',
    title: 'Class Assissment content source',
    key: 'ca_content_sources',
    purpose: 'Allow teacher to view multiple classes of same subject from one class',
    description: '',
    field_type: 'toggle-switch-common',
    default_value: '',
    value: '',
    is_default: false,
  },
  class_setting_show_multi_grade: {
    master_tenant_settings_key: 'class_setting_show_multi_grade',
    title: 'Show multi grade',
    key: 'class_setting_show_multi_grade',
    purpose: 'Set the default content search from different sources in class actvities page',
    description: '',
    field_type: 'toggle-switch-common',
    default_value: '',
    value: true,
    is_default: false,
  },
  default_class_course_content_visibility: {
    master_tenant_settings_key: 'default_class_course_content_visibility',
    title: 'Default class course content visibility',
    key: 'default_class_course_content_visibility',
    purpose: 'Content visbility on teacher side default will be on',
    description: '',
    field_type: 'toggle-switch-common',
    default_value: '',
    value: true,
    is_default: false,
  },
};

export const TENANT_SETTINS_TOGGLE_ELEMENT: any = [
  'toggle-boolean',
  'toggle-string',
];

export const TENANT_SETTINS_CUSTOM_UI_COMPONENT: any = {
  'default_groups': 'default-groups',
  'navigator_class_setting': 'navigator-class-setting',
  'default_roster_subject': 'default-roster-subject',
  'default_roster_grades': 'default-roster-grades',
  'roster_subject_keywords': 'roster-subject-keywords',
  'pending.grading.items.interval.day': 'custom-notifications',
  'taxonomy-picker': 'taxonmy-picker',
  'tx_fw_prefs': 'tx-fw-preference',
  'preferred_facet_subject_codes': 'pref-facet-subject',
  'tx_sub_classifier_prefs': 'tx-sub-classifier-prefs',
  'tx_sub_prefs': 'tx-subject-preference',
  'competency_completion_min_score': 'completion-score',
  'mastery_on_content_completion_setting': 'mastery-content-completion-setting',
  'enable_milestone_view_at_fw_level': 'enable-milestore-fw',
  'ca_content_sources': 'content-source',
  'minimum_starting_grade_for_diagnostic_flow': 'min-starting-diagnostic',
  'working_days': 'working-days',
  'navigator_route_map_view_applicable': 'nav-route-map-view',
  'library_visibility': 'library-visibility',
  'default_view_sns_at_fw_level': 'default-view-sns-fw-level',
  'signature_contents_publishers': 'signature-contents-publishers',
  'data_deletion_timeframe_in_days': 'input-number',
  'enable_marker': 'enable_marker',
  'default_password': 'password-validate',
};

export const TENANT_SETTINS_PARAMETER_TYPE: any = {
  'input-text': 'b-form-input',
  'toggle-boolean': 'b-form-checkbox',
  'toggle-string': 'on-off-checkbox',
  'input-json': 'b-form-input',
};

export const TENANT_DEFAULT: any = {
  enable_study_player_fullscreen_mode: 'false', //
  lesson_label_course_map: 'lesson',
  learner_data_visibilty_pref: 'true',
  add_students_by: 'username',
  enable_cls_video_conf_setup: 'false',
};

export const UPLOAD_TYPE_LIST: any = [
  'logo_url',
  'study_player_pg_image',
];

export const TENANT_SETTINS_DISABLED_SETTING_KEY: any = [
  'default_password', // Privacy
  'is_default_gradable_eval_result_correct_value', // Admin
  'fc_visibility',  // General
];

export const USER_LIST_SETTINGS: any = [
  {
    label: 'Name',
    key: 'name',
    tdClass: 'custom-text-color',
  },
  {
    label: 'Designation',
    key: 'designation',
    tdClass: 'custom-text-color',
  },
  {
    label: 'Email address',
    key: 'email',
    tdClass: 'custom-text-color',
  },
  {
    label: 'Roles',
    key: 'rolesName',
    tdClass: 'custom-text-color',
  },
  // {
  //   label: 'Cohorts',
  //   key: 'cohorts',
  //   tdClass: 'custom-text-color',
  // },
];

export const RESOURCE_TYPES_LIST = [
  {
    label: 'Audio Resource',
    id: 'audio',
  },
  {
    label: 'Video Resource',
    id: 'video',
  },
  {
    label: 'Image Resource',
    id: 'image',
  },
  {
    label: 'Interactive Resource',
    id: 'interactive',
  },
  {
    label: 'Text Resource',
    id: 'text',
  },
  {
    label: 'Web Resource',
    id: 'web-resource',
  },
];

export const PERMISSION_CHECK: any = {
  viewLearnStore: 'VIEW_LEARN_STORE',
  viewDataLake: 'VIEW_DATA_LAKE',
  viewSetup: 'VIEW_SETUP',
  viewTenant: 'VIEW_TENANT',
  createTenant: 'CREATE_TENANT',
  editTenant: 'EDIT_TENANT',
  deleteTenant : 'INACTIVE_TENANT',
  viewLearningRegistry: 'VIEW_LEARNING_REGISTRY',
  viewPartner: 'VIEW_PARTNER',
  createParter: 'CREATE_PARTNER',
  viewProduct: 'VIEW_PRODUCT',
  GENERATE_ACCESS_CODE: 'GENERATE_ACCESS_CODE',
  USER_REGISTER_APPROVE: 'USER_REGISTER_APPROVE',
  createProduct: 'CREATE_PRODUCT',
  viewTool: 'VIEW_TOOLS',
  createTool: 'CREATE_TOOLS' ,
  viewRosterOnly: 'VIEW_ROSTER',
  resetPassword: 'RESET_PASSWORD',
  rosterMobileView: 'ALLOW_ROSTERING_AND_REENROLLMENT',
  updateRole: 'UPDATE_USER_ROLE',
  showRecruiterMenu: 'SHOW_RECRUITER_MENU',
  independentStudy: 'INDEPENDENT_STUDY',
  communityHub: 'COMMUNITY_HUB',
};

export const REGISTRY_TABLE_FIELDS_LIBRARY: any = {
  districtUserContent: [
    {
      label: 'Provider',
      key: 'providerName',
    },

    {
      label: 'Product description',
      key: 'contentDescription',
      tdClass: 'ellipsis-notes',
    },
    {
      label: 'Subjects',
      key: 'subject.title',
    },
    {
      label: 'Grades',
      key: 'contentGrades',
    },
    {
      label: 'Subscription',
      key: 'subscriptionsApproved',
    },
  ],
  districtUserTool: [
    {
      label: 'Tool name',
      key: 'toolName',
    },
    {
      label: 'Provider',
      key: 'providerName',
    },
    {
      label: 'Tool description',
      key: 'toolDetails.description',
      tdClass: 'ellipsis-notes',
    },
    {
      label: 'Subjects',
      key: 'subjectList',
    },
    {
      label: 'Grades',
      key: 'gradeList',
    },
    {
      label: 'Subscription',
      key: 'subscriptionsApproved',
    },
  ],
  contentProviderContent: [
    {
      label: 'Partner Name',
      key: 'providerName',
    },
    {
      label: 'Description',
      key: 'contentDescription',
      tdClass: 'ellipsis-notes',
    },
    {
      label: 'Subjects',
      key: 'subject.title',
    },
    {
      label: 'Grades',
      key: 'contentGrades',
    },
    // {
    //   label: 'Tool description',
    //   key: 'toolDescription',
    // },
    {
      label: 'Subscription requests',
      key: 'subscriptionRequest',
    },
  ],
  contentProviderTool: [
    {
      label: 'Name',
      key: 'toolName',
    },
    {
      label: 'Description',
      key: 'toolDetails.description',
      tdClass: 'ellipsis-notes',
    },
    {
      label: 'Tool Type',
      key: 'toolType',
    },
    {
      label: 'Subjects',
      key: 'subjectList',
    },
    {
      label: 'Grades',
      key: 'gradeList',
    },
    {
      label: 'Subscription requests',
      key: 'subscriptionRequest',
    },
  ],
  superUserContent: [
    {
      label: 'Partner name',
      key: 'providerName',
    },
    {
      label: 'Description',
      key: 'contentDescription',
      tdClass: 'ellipsis-notes',
    },
    {
      label: 'Subjects',
      key: 'subject.title',
    },
    {
      label: 'Grades',
      key: 'contentGrades',
    },
    {
      label: 'Subscription requests',
      key: 'subscriptionRequest',
    },
  ],
  superUserTool: [
    {
      label: 'Name',
      key: 'toolName',
    },
    {
      label: 'Description',
      key: 'toolDetailsDescription',
      tdClass: 'ellipsis-notes',
    },
    {
      label: 'Tool Type',
      key: 'toolDetails.toolType',
    },
    {
      label: 'Subjects',
      key: 'subjectList',
    },
    {
      label: 'Grades',
      key: 'gradeList',
    },
    {
      label: 'Subscription requests',
      key: 'subscriptionRequest',
    },
  ],
  partnerRegistry: [
    {
      label: 'Partner Name',
      key: 'providerName',
      tdClass: 'provider-info',
    },
    {
      label: 'Type',
      key: 'partner_type',
    },
    {
      label: 'Summary information',
      key: 'additional_info',
      tdClass: 'ellipsis-notes',
    },
    {
      label: '# of content products & tools',
      key: 'contentProductsToolsNo',
      thClass: 'content-product-tool',
    },
    {
      label: 'Disciplines',
      key: 'disciplines',
    },
  ],
};

export const TENANT_TYPES: any = {
  school : 'School',
  school_district: 'School District',
  contentDevelopers: 'Content Developers',
  funders: 'Funders',
  integrationPartners: 'Integration Partners',
  labSchools: 'Lab Schools',
  overallStats: 'Overall Stats',
  researchers: 'Researchers',
  schools: 'Schools',
};

export const TENANT_ROSTER_FORMAT: any = {
  'one_roster_1.0': 'One Roster 0',
  'one_roster_1.1': 'One Roster 1',
  'custom_template': 'Custom',
  'third_party_sync': 'Third Party Sync',
};

export const MARKER_TYPES: any = {
  txImplicitMarker: 'Implicit Marker',
  txExplicitMarker: 'Explicit Marker',
};

export const DEFAULT_CATALOG_STRING: any = {
  resource: {
    audio_resource: { name: 'Audio', colorCode: '#377eae' },
    video_resource: { name: 'Videos', colorCode: '#429aa9' },
    interactive_resource: { name: 'Interactive', colorCode: '#59b3a1' },
    image_resource: { name: 'Images', colorCode: '#78c69c' },
    webpage_resource: { name: 'Webpages', colorCode: '#99d59a' },
    text_resource: { name: 'Text', colorCode: '#b8e297' },
  },
  question: {
    multiple_choice_question: { name: 'Multiple Choice', colorCode: '#377eae' },
    multiple_answer_question: { name: 'Multiple Answer', colorCode: '#429aa9' },
    true_false_question: { name: 'True Or False', colorCode: '#59b3a1' },
    fill_in_the_blank_question: { name: 'Fill In The Blank', colorCode: '#78c69c' },
    hot_spot_image_question: { name: 'Multiple Select - Image', colorCode: '#99d59a' },
    hot_spot_text_question: { name: 'Multiple Select - Text', colorCode: '#b8e297' },
    hot_text_highlight_question: { name: 'Highlight Text', colorCode: '#d4ed96' },
    hot_text_reorder_question: { name: 'Drag And Drop Order', colorCode: '#e9f69d' },
    open_ended_question: { name: 'Open Ended', colorCode: '#f6f9a7' },
  },
};

export const SUPER_ADMIN_TENANT: string = 'ba956a97-ae15-11e5-a302-f8a963065976';
export const INDEPENDENT_POPUP_CONTENT: any = {
  success : {
    title: 'Confirm Publishing',
    description: 'Are you sure you want to publish this course? Once published, it will be visible to your selected audience. Ensure all details are accurate before proceeding.',
    buttonName: 'Confirm Publishing',
  },
  confirmSuccess : {
    title: 'Publishing successful',
    description: 'Your course, [Course Title], has been published and is now live. It is visible to your selected audience. You can always edit the course details if needed.',
    buttonName: 'OK',
  },
  updateSuccess : {
    title: 'Confirm Update',
    description: 'Are you sure you want to update this course? The changes will be saved and reflected for all users. Ensure all updates are correct before proceeding',
    buttonName: 'Update Program',
  },
  updateConfirm : {
    title: 'Program Updated Successfully!',
    description: 'Your changes to the course, [Course Title], have been saved and are now visible to your audience.',
    buttonName: 'OK',
  },
};
